import { makeVar } from '@apollo/client/core';

export const mainDrawerOpen = makeVar<boolean>(false);
export const highlightTourOpen = makeVar<boolean>(false);
